import { RefObject, useEffect } from 'react';

/** Calls handler on pointer down outside all given refs. */
export function useClickOutside(refs: RefObject<HTMLElement>[], handler: (e: PointerEvent) => void, active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const onDown = (e: PointerEvent) => {
      if (refs.some((r) => r.current && r.current.contains(e.target as Node))) return;
      handler(e);
    };
    document.addEventListener('pointerdown', onDown);
    return () => document.removeEventListener('pointerdown', onDown);
  }, [refs, handler, active]);
}
